import { configureStore } from '@reduxjs/toolkit';
import usersReducer from './slices/usersSlice';
import experiencesReducer from './slices/experiencesSlice';
import pendingExperiencesReducer from './slices/pendingExperiencesSlice';
import contentReducer from './slices/contentSlice';

const store = configureStore({
  reducer: {
    users: usersReducer,
    experiences: experiencesReducer,
    pendingExperiences: pendingExperiencesReducer,
    content: contentReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
  devTools: typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION__,
});

export default store;
